import React, { useCallback, useState, useMemo } from "react";
import './EventTypeListItem.css';

export const EventTypeListItem = ({ appState, eventType, onSelect }) => {
    const [isLoading, setIsLoading] = useState(false);
    const onClick = useCallback(e => {
        if (isLoading) {
            return;
        }
        setIsLoading(true);
        onSelect(eventType);

    }, [eventType, onSelect, isLoading, setIsLoading]);

    const connected = useMemo(() => {
        if (!!appState) {
            let total = 0;
            for (const room of appState.rooms.filter(x => x.type === eventType.id)) {
                total += room.participants.length;
            }
            return total;
        }
        return 0;
    }, [appState]);

    return <div className='event-type-list-item'>
        <div className='event-type__box' onClick={onClick}>

            {!isLoading && <div className='event-type__calltoaction'>
                <button>Enter room</button>
            </div>}

            {!!isLoading && <div className='event-type__calltoaction event-type__calltoaction--shown'>
                <button>Loading...</button>
            </div>}

            <h3 className='event-type__name'>{eventType.name}</h3>
            <p className='event-type__description'>{eventType.description}</p>
            <div className='event-type__description'>
                <strong>Max participants: {eventType.maxParticipants}</strong>
                {!!connected && <div className='event-type__connected'>{connected} connected</div>}

            </div>
        </div>
    </div>;
};